import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import KeyIcon from "@mui/icons-material/Key";
import { useHistory, Link } from "react-router-dom";
import { toast } from "react-toastify";
import LockIcon from "@mui/icons-material/Lock";

import Logo from "../../assets/images/logo.png";
import { ButtonComponent } from "../../component";
import FormInput from "../../component/common/outlined-input";
import { loginValidation } from "../../validation/auth";
import { getCookies, setCookies, deleteCookies } from "../../helper/constant";
import { login } from "../../store/actions";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    // checked: false,
  });
  const [error, setError] = useState({});
  const [disable, setDisable] = useState(false);
  const [visibility, setVisibility] = useState({
    password: false,
    confirmPwd: false,
  });

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      email: getCookies("emailCookie"),
      password: getCookies("passwordCookie"),
      // checked: getCookies("emailCookie") ? true : false,
    }));
  }, []);

  const handleChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
      [name]: "",
    }));
    if (name === "password") {
      if (event?.key === "Enter") {
        handleSubmit();
      }
    }
  };
  const handleCheckbox = (event) => {
    setFormData((prevState) => ({
      ...prevState,
      checked: event?.target?.checked,
    }));
    if(event?.target?.checked) {
      setCookies("emailCookie",formData?.email)
      setCookies("passwordCookie",formData?.password)
    } else {
      deleteCookies("emailCookie")
      deleteCookies("passwordCookie")
    }
  };
  const handleClickNewPassword = (name) =>
    setVisibility((prev) => ({ ...prev, [name]: !visibility[name] }));

  const handleSubmit = () => {
    const { errors, isValid } = loginValidation(formData);
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 4000);
    if (isValid) {
      dispatch(
        login({
          form: formData,
          callback: (data) => {
            console.log(data, "DATA")
            if (data?.code === 200) {
              // setCookies("SubAdminPermission",JSON.stringify(data?.data?.user?.permissions))
              localStorage.setItem("SubAdminPermission",JSON.stringify(data?.data?.user?.permissions))
              if (getCookies("token") !== null) {

                history.push("/dashboard");
              }
            } else {
              toast.error(data?.message);
              deleteCookies("emailCookie")
              deleteCookies("passwordCookie")
            }
          },
        })
      );
    } else {
      setError(errors);
    }
  };

  return (
    <Box className={"login-page"}>
      <Box className={"login-wrap"}>
        <img
          src={Logo}
          alt={"logo"}
          className={"logo-image"}
          srcSet={Logo}
          loading="lazy"
        />
        <FormInput
          placeholder={"Enter email"}
          type={"email"}
          name={"email"}
          id={"email"}
          value={formData?.email}
          icon={<AccountCircle />}
          onChange={(e) => handleChange(e)}
          handleKeyPress={handleChange}
          helperText={error?.email}
          error={error?.email}
          classes={"login-input"}
        />

        <FormControl
          variant="standard"
          sx={{ margin: "5px 5px", maxWidth: "400px" }}
        >
          <OutlinedInput
            id="filled-adornment-password"
            className={`input-box`}
            type={visibility.password ? "text" : "password"}
            name={"password"}
            placeholder={"Enter password"}
            value={formData?.password}
            error={error.password}
            onChange={(e) => handleChange(e)}
            onKeyPress={(e) => handleChange(e)}
            disabled={disable}
            sx={{
              margin: "0px",
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => {
                    handleClickNewPassword("password");
                  }}
                  edge="end"
                >
                  {!visibility.password ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            startAdornment={
              <InputAdornment
                position="start"
                sx={{
                  padding: "0px 0px !important",
                }}
              >
                <KeyIcon />
              </InputAdornment>
            }
          />
          <FormHelperText error className={`helper-text`}>
            {error.password}
          </FormHelperText>
        </FormControl>
        <FormGroup sx={{ margin: "0px 5px", maxWidth: "400px" }}>
          <FormControlLabel
            control={
              <Checkbox
                name={"checked"}
                checked={formData?.checked}
                onChange={handleCheckbox}
              />
            }
            className="poppins-font-family f-12"
            label="Remember me"
          />
        </FormGroup>
        <Box justifyContent={"center"} className="d-flex">
          <ButtonComponent
            variant="contained"
            buttonName="Log In"
            color={"warning"}
            className={"login-btn common-btn"}
            handleClick={handleSubmit}
            disabled={disable}
          />
        </Box>

        <Link to={"/forgot-password"} className={"forgotpwd-link"}>
          <LockIcon className="me-2" color={"action"} />
          <span className="f-12">Forgot your username/password?</span>
        </Link>
      </Box>
    </Box>
  );
};

export default Login;
